<div class="height-match-parent" style="max-width: 100vw">
  <mat-toolbar class="width-match-parent">
    <mat-toolbar-row
      class="first-toolbar-row width-match-parent no-select mat-elevation-z2"
      fxLayoutAlign="space-between center"
      >
      <div fxLayoutAlign="center center">
        @if (logoWithName) {
          <a routerLink="/">
            <img [src]="logoWithName" alt="Recrewt Logo" class="nav-home-logo" />
          </a>
        }
      </div>

      @if (true) {
        <div class="m-r-s" fxLayoutAlign="start center">
          @if (isNotRottalInn$ | async) {
            @if (activeTeam$ | async; as activeTeam) {
              <button [matMenuTriggerFor]="teamMenu" class="m-r-1" color="primary" mat-flat-button>
                {{ (activeTeam$ | async)?.name ?? 'TOOLBAR.USER.select_team' | translate }}
                <mat-icon>expand_more</mat-icon>
              </button>
              <mat-menu #teamMenu="matMenu">
                <button [matMenuTriggerFor]="teams" mat-menu-item>
                  <mat-icon>groups</mat-icon>
                  {{ 'TOOLBAR.USER.change_team' | translate }}
                </button>
                @if (activeTeam?.privileges?.role === 0) {
                  <button (click)="editTeam()" mat-menu-item>
                    <mat-icon>edit</mat-icon>
                    {{ 'TOOLBAR.USER.edit_team' | translate }}
                  </button>
                }
              </mat-menu>
              <mat-menu #teams="matMenu">
                @for (team of teams$ | async; track team) {
                  <button
                    (click)="changeTeam(team._id)"
                    [class.text-weight-bold]="team._id === activeTeam._id"
                    [disabled]="team._id === activeTeam._id"
                    mat-menu-item
                    >
                    {{ team._id === activeTeam._id ? '✓' : '' }} {{ team.name }}
                  </button>
                }
              </mat-menu>
            }
          }
          <button [matMenuTriggerFor]="menu" mat-icon-button>
            @if ((user$ | async)?.email; as email) {
              <recrewt-name-letter-avatar [name]="email"
                size="medium"
               />
            }
          </button>
        </div>
      }
    </mat-toolbar-row>
    <mat-toolbar-row class="second-toolbar-row width-match-parent">
      <recrewt-breadcrumbs class="width-match-parent" />
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="toolbar-content">
    <div class="nav-content height-match-parent">
      <router-outlet />
    </div>
  </div>
</div>

<mat-menu #menu="matMenu">
  <button (click)="logout()" mat-menu-item>
    <mat-icon>logout</mat-icon>
    <span>{{ 'TOOLBAR.USER.logout' | translate }}</span>
  </button>
</mat-menu>
